import { render } from "./Decont.vue?vue&type=template&id=377dd4d7"
import script from "./Decont.vue?vue&type=script&lang=js"
export * from "./Decont.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__